import { 
  fetch, 
  fetchCore 
} from "data/controls";
import {
  loadWPContent
} from 'data/redux/actions'

/*
 * GAMES
 */

export const getGames = (userId) => dispatch => {

  return fetch(`/game/list/${userId}`)
    .then(games => {
                  
      dispatch(hydrateGames(games))

      games.forEach(game => {

        dispatch(loadWPContent(game.wpId))
      })
    })
}

export const hydrateGames = (games, reset) => {
  return {
    type: 'HYDRATE_GAMES',
    payload: {
      games,
      reset
    }
  };
}

export const _getGame = (userId, gameId) => {

  return fetch(`/game/${gameId}/${userId}`)
}

export const getGame = (userId, gameId) => (dispatch) => {

  return _getGame(userId, gameId)
          .then(game => dispatch(hydrateGame(gameId, game)))
          .catch(error => {
            console.log('ERROR!!!', error)
          })
}

export const hydrateGame = (gameId, game) => {
  return {
    type: 'HYDRATE_GAME',
    payload: {
      gameId,
      game
    }
  };
}

export const getAllEvents = (gameId) => (dispatch) => {

  return fetch(`/admin/games/${ gameId }/events`)
          .then(events => dispatch(hydrateAllEvents(gameId, events)))
          .catch(error => {
            console.log('ERROR!!!', error)
          })
}

export const hydrateAllEvents = (gameId, events) => {
  return {
    type: 'HYDRATE_ALLEVENTS',
    payload: {
      gameId,
      events
    }
  };
}

export const getGameUsers = gameId => (dispatch, getState) => {

  const state = getState()
  if(state.games[gameId].gameusersloaded) { return }

  return fetch(`/admin/games/${gameId}/users`)
          .then(users => dispatch(hydrateGameUsers(gameId, users)))
          .catch(error => {
            console.log('ERROR!!!', error)
          })
}

export const hydrateGameUsers = (gameId, users) => {
  return {
    type: 'HYDRATE_GAME_USERS',
    payload: {
      gameId,
      users
    }
  };
}

export const setContentGame = (gameId, content) => {

  return {
    type: 'SET_CONTENT_GAME',
    payload: {
      gameId,
      content
    }
  };
}

export const getWPUsers = (gameId) => (dispatch, getState) => { 

  const state = getState()
  if(state.games[gameId].wpusersloaded) { return }
  
  return fetchCore(`/gamewpusers/${gameId}`)
          .then(result => dispatch(hydrateWPUsers(gameId, result)) )
}

export const HYDRATE_WP_USERS = 'HYDRATE_WP_USERS'
export const hydrateWPUsers = (gameId, users) => ({ 
  type: HYDRATE_WP_USERS,
  payload: {
    gameId,
    users
  }
})


export const gameNewsLoad = (gameId) => (dispatch, getState) => {

  return fetchCore(`/blog/${gameId}`)
          .then(result => dispatch(hydrateGameNews(gameId, result)) )

}

export const HYDRATE_GAME_NEWS = 'HYDRATE_GAME_NEWS'
export const hydrateGameNews = (gameId, news) => ({ 
  type: HYDRATE_GAME_NEWS,
  payload: {
    gameId, 
    news
  }
})

export const saveUserData = (userId, data) => (dispatch) => {
  
  let url = `/users/${userId}/update`

  let params = {
    method: 'POST',
    body: data
  }

  return fetch(url, params)
          .then(data => 
            dispatch({
              type: 'UPDATE_USER_DATA',
              payload: {
                data: data.data
              }
            })
          )
}
